import { createDefaultTimelineElement } from './create-default-timeline.element';

export function createTimelineCellTypeElement(_index: number): HTMLElement {
  return createDefaultTimelineElement(_index);
}
